import ConfirmReactivation from './confirm-reactivation';
export default ConfirmReactivation;
